export default "__VITE_ASSET__GSpmQLNE__"